// src/App.js
import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Features from './components/Features';
import Commands from './components/Commands';
import Settings from './components/Settings';
import Guide from './components/Guide';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import './styles/main.css';

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <Features />
        <Commands />
        <Settings />
        <Guide />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;